import React, { useEffect } from 'react';

import * as PopupAlertManager from './index';
import AlertDialog from './Alert';
import { Box } from '@mui/material';

const AlertWrapper = ({ classes, ...props }) => {
  const [state, setState] = React.useState(0);
  PopupAlertManager.bindAlertModalUpdate(setState);
  const { alerts } = PopupAlertManager.getState();

  const renderAlerts = Object.entries(alerts).map(([i, alert]) => (
    <AlertDialog {...alert} key={i} onDismiss={() => PopupAlertManager.clearModal(i)} />
  ));

  return (
    <Box
      display="flex"
      flexDirection={'column'}
      position="absolute"
      {...props}
      zIndex="100000"
      sx={{
        left: 16,
        right: 16,
        top: 16,
      }}
    >
      {renderAlerts}
    </Box>
  );
};

export default AlertWrapper;
